import { Paginated, Sortable } from "@ac-expo/api-types";

export type ReportingFilter = {
  searchText?: string;
  startDate?: string;
  endDate?: string;
} & Sortable<Paginated>;

export const reportingQueryKeys = {
  all: (filters?: ReportingFilter) => ["reporting", filters],
};
